module.exports = __webpack_public_path__ + "@/assets/img/06.72e28541.svg";